export const environment = {
  cognito: {
    userPoolId: 'ap-southeast-2_95Ck0cJfx',
    userPoolWebClientId: '78n5c5t6bntm2jdkkoao3rhian',
  },
  api: {
    invokeUrl:
      'https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_95Ck0cJfx',
  },
  base_url: 'https://ej3ljwqr2i.execute-api.ap-southeast-2.amazonaws.com/DEV',
  production: false,
  mock: true, // Indicates if the environment is in mock mode
  logging: true, // Enable or disable logging
  ai: {
    enabled: true,
    endpoint: 'https://ej3ljwqr2i.execute-api.ap-southeast-2.amazonaws.com/DEV/ai',
  },
};
